import React, { useEffect } from "react";
import "./About.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaBullseye, FaCheckCircle, FaTasks } from "react-icons/fa";

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // initialize AOS
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <section
        className="about-hero-section"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL + "/images/hero1.jpg"})`,
        }}
      >
        <div className="overlay"></div>
        <div className="about-hero-content" data-aos="fade-up">
          <h1>About Us</h1>
          <p>Learn more about Riksons Inspection Services</p>
        </div>
      </section>

      {/* Company Profile */}
      <section className="company-profile">
        <div className="profile-text" data-aos="fade-right">
          <h2>Company Profile</h2>
          <ul>
            <li>“Riksons Inspection Services” is leading and developing in inspection of quality and NDT services.</li>
            <li>We assure great quality and excellent services.</li>
            <li>Riksons Inspection Services has a knowledgeable team available to provide excellent quality services to customers.</li>
            <li>Started in September 2021 at Kirloskarwadi, with prior experience of 6-7 years.</li>
          </ul>
        </div>
        <div className="profile-image" data-aos="fade-left">
          <img src={process.env.PUBLIC_URL + "/images/hero2.jpeg"} alt="Company" />
        </div>
      </section>

      {/* Our Strengths */}
      <section className="our-strengths" data-aos="fade-up">
        <div className="strengths-container">
          <h2>Our Strengths</h2>
          <p>
            The strength earned by our organization today is due to the professionally qualified staff and innovative ideas of management, keeping the company updated with the latest technologies.
          </p>
        </div>
      </section>

      {/* Vision and Mission */}
      <section className="vision-mission-row">
        <div className="block" data-aos="fade-right">
          <FaBullseye className="icon blue-icon" />
          <h2>Vision</h2>
          <p>To become a ‘Complete Solution Provider’ of Inspection components by providing standard quality at competitive cost with excellent service.</p>
        </div>

        <div className="block" data-aos="fade-left">
          <FaCheckCircle className="icon blue-icon" />
          <h2>Mission</h2>
          <ul>
            <li>To provide excellent quality service for NDT, Machining, Fabrications, Expedition, etc.</li>
            <li>To continually improve our process and service.</li>
          </ul>
        </div>
      </section>

      {/* Quality Policy */}
      <section className="quality-policy-row" data-aos="fade-up">
        <div className="block quality-policy-block">
          <FaTasks className="icon blue-icon" />
          <h2>Quality Policy</h2>
          <ul>
            <li>Committed to inspecting products carefully, fulfilling customer requirements at competitive cost.</li>
            <li>Continual improvement of performance by complying with quality management system requirements.</li>
            <li>Customer-first strategy, prioritizing understanding customer needs and providing comprehensive solutions.</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default About;
